// Lib
import React from 'react';

// Utils
import { getWidth } from '../../../common/elements/utils/elementPropertyUtils';

// Constants
import { ELEMENT_DEFAULT_WIDTH } from '../../../common/elements/elementConstants';
import { ImMNElement } from '../../../common/elements/elementModelTypes';

type RequiredProps = {
    setElementSizeAndPosition: (args: { width: number }) => void;
    gridSize: number;
    element: ImMNElement;
};

export default <T extends RequiredProps>(getDefaultMaxWidth: (props: T) => number) =>
    (DecoratedComponent: React.ComponentType<T>): React.FC<T> => {
        return (props: T) => {
            const handleDoubleClick = (event: MouseEvent) => {
                const { gridSize, element } = props;

                if (!getDefaultMaxWidth) return;

                event.preventDefault();
                event.stopPropagation();

                const savedWidth = getWidth(element) || ELEMENT_DEFAULT_WIDTH;

                const defaultMaxWidth = getDefaultMaxWidth(props);

                // Only toggle to the default width of the media if we're currently at the default element width
                const width = savedWidth === ELEMENT_DEFAULT_WIDTH ? defaultMaxWidth / gridSize : ELEMENT_DEFAULT_WIDTH;

                props.setElementSizeAndPosition({ width });
            };
            return <DecoratedComponent {...props} handleDoubleClick={handleDoubleClick} />;
        };
    };
